import _ from "lodash";

export const getArrayUnion = (array1, array2, prop, uniqueId) => {
  let updateArray = { ...array2 };
  if (array2 && array2[prop] && array1) {
    updateArray[prop].edges = _.unionBy(
      array1[prop].edges,
      array2[prop].edges,
      uniqueId
    );
    updateArray.__typename = array1[prop].__typename;
  }
  return updateArray;
};

export const getQueryUpdate = (prev, fetchMoreResult, type) => {
  if (!fetchMoreResult) {
    return prev;
  }
  const results = { ...fetchMoreResult };

  if (prev[type]) {
    results[type].nodes = [...prev[type].nodes, ...results[type].nodes].filter(
      n => n
    );
  }
  return results;
};

export const cleanUrl = (url, prefix = "") =>
  url && prefix + url.replace(/https?:\/\/[^/]+/, "");

export default () => {};
